// Prüft eigene Motive vor dem Upload im Browser mit nsfwjs (https://github.com/infinitered/nsfwjs).
// Bibliothek (inkl. TensorFlow.js, ~2,7 MB) und Modell (MobileNetV2, ~2,6 MB) liegen in R2 und kommen
// über den App-Proxy der Fulfillment-App (obermain-therme-fulfillment app/routes/proxy.nsfwjs.tsx),
// sobald jemand ein eigenes Motiv auswählt. Genutzt von product-personalization.js und
// line-item-personalization-edit.js.
// Nur eine Hürde im Browser: Wer das Skript umgeht, kann trotzdem hochladen.
(() => {
    if (window.nsfwCheck) return;

    const BASE_URL = '/apps/personalization/nsfwjs/4.4.0/';
    const SCRIPT_URL = BASE_URL + 'nsfwjs.min.js';
    const MODEL_URL = BASE_URL + 'model.json';
    // Badebilder stuft das Modell oft als "Sexy" ein – für eine Therme wird nur bei "Porn" und
    // "Hentai" gesperrt, und zwar wenn beide zusammen über dieser Wahrscheinlichkeit liegen.
    const BLOCKED_CLASSES = ['Porn', 'Hentai'];
    const BLOCK_THRESHOLD = 0.7;

    let modelPromise = null;

    function loadScript(src) {
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = src;
            script.async = true;
            script.onload = resolve;
            script.onerror = () => reject(new Error('Script failed to load: ' + src));
            document.head.appendChild(script);
        });
    }

    function loadModel() {
        if (!modelPromise) {
            modelPromise = (window.nsfwjs ? Promise.resolve() : loadScript(SCRIPT_URL))
                .then(() => window.nsfwjs.load(MODEL_URL))
                .catch((err) => {
                    modelPromise = null; // beim nächsten Upload erneut versuchen
                    throw err;
                });
        }
        return modelPromise;
    }

    async function classify(model, file) {
        const url = URL.createObjectURL(file);
        try {
            const img = new Image();
            img.src = url;
            await img.decode();
            return await model.classify(img); // alle 5 Klassen
        } finally {
            URL.revokeObjectURL(url);
        }
    }

    window.nsfwCheck = {
        // Beim Öffnen des Dateidialogs aufrufen, damit das Modell lädt, während ausgewählt wird.
        preload() {
            loadModel().catch(() => {});
        },

        // false nur, wenn das Bild als anstößig erkannt wurde. Lässt sich das Modell nicht laden oder
        // das Bild nicht prüfen, ist das Ergebnis true, damit ein CDN-Ausfall keine Bestellung blockiert.
        async isAllowed(file) {
            try {
                const model = await loadModel();
                const predictions = await classify(model, file);
                const score = predictions
                    .filter((p) => BLOCKED_CLASSES.includes(p.className))
                    .reduce((sum, p) => sum + p.probability, 0);
                return score < BLOCK_THRESHOLD;
            } catch (err) {
                console.warn('[nsfw-check] check skipped', err);
                return true;
            }
        },
    };
})();
